import moment   from 'moment';
import {currentUser, fullYear, priceView} from '@utilities/functions';


moment.locale('de', {
    months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
    weekdaysShort : 'Son_Mon_Die_Mit_Don_Fre_San'.split('_'),
    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
});

export const months = ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'];

export const defaultAddConditionText = function (state, condition) {
    return '';
};

export const defaultConditions = function (state) {
    const offerdate = new Date();
    offerdate.setDate(offerdate.getDate() + 14);

    const startAt = moment(state.order.startAt, 'DD.MM.YYYY');

    let conditions = [];
    conditions.de_DE = [
        {
            category: 'Angebotsoption',
            subcategory: 'zum Paketpreis:',
            days: null,
            conditionText: '',
            type: 'date',
            key: `${+new Date()}-offer-1`,
            deadlineDate: offerdate.toLocaleDateString('de-DE'),
            deadlineText: ''
        },
        {
            category: 'Zahlungen',
            subcategory: 'von Paketleistungen:',
            days: 60,
            conditionText: '20% Anzahlung vom Paketpreis',
            type: 'days',
            key: `${+new Date}-payment-1`,
            deadlineDate: startAt.clone().subtract(60, 'day').format('DD.MM.YYYY'),
            deadlineText: ''
        },
        {
            category: 'Zahlungen',
            subcategory: 'von Paketleistungen:',
            days: 7,
            conditionText: 'Zahlung des Gesamtpreises',
            type: 'days',
            key: `${+new Date()}-payment-2`,
            deadlineDate: startAt.clone().subtract(7, 'day').format('DD.MM.YYYY'),
            deadlineText: ''
        },
        {
            category: 'Stornokosten',
            subcategory: 'bei Stornierung von Paketleistungen:',
            days: 60,
            conditionText: 'kostenfrei',
            type: 'days',
            key: `${+new Date()}-cancelation-1`,
            deadlineDate: startAt.clone().subtract(60, 'day').format('DD.MM.YYYY'),
            deadlineText: ''
        },
        {
            category: 'Stornokosten',
            subcategory: 'bei Stornierung von Paketleistungen:',
            days: 28,
            conditionText: '30% des Paketpreises',
            type: 'days',
            key: `${+new Date}-cancelation-2`,
            deadlineDate: startAt.clone().subtract(28, 'day').format('DD.MM.YYYY'),
            deadlineText: ''
        },
        {
            category: 'Stornokosten',
            subcategory: 'bei Stornierung von Paketleistungen:',
            days: 14,
            conditionText: '50% des Paketpreises',
            type: 'days',
            key: `${+new Date}-cancelation-3`,
            deadlineDate: startAt.clone().subtract(14, 'day').format('DD.MM.YYYY'),
            deadlineText: ''
        },
        {
            category: 'Stornokosten',
            subcategory: 'bei Stornierung von Paketleistungen:',
            days: 7,
            conditionText: '75% des Paketpreises',
            type: 'days',
            key: `${+new Date}-cancelation-4`,
            deadlineDate: startAt.clone().subtract(7, 'day').format('DD.MM.YYYY'),
            deadlineText: ''
        },
        {
            category: 'Stornokosten',
            subcategory: 'bei Stornierung von Paketleistungen:',
            days: 6,
            conditionText: '95% des Paketpreises',
            type: 'days',
            key: `${+new Date()}-cancelation-5`,
            deadlineDate: startAt.clone().subtract(6, 'day').format('DD.MM.YYYY'),
            deadlineText: ''
        },
    ];
    conditions.fr = [
        {
            category: 'Angebotsoption',
            subcategory: 'zum Paketpreis:',
            days: null,
            conditionText: '',
            type: 'date',
            key: `${+new Date()}-offer-1`,
            deadlineDate: offerdate.toLocaleDateString('de-DE'),
            deadlineText: ''
        },
        {
            category: 'Zahlungen',
            subcategory: 'von Paketleistungen:',
            days: 60,
            conditionText: '20% Anzahlung vom Paketpreis',
            type: 'days',
            key: `${+new Date()}-payment-1`,
            deadlineDate: startAt.clone().subtract(60, 'day').format('DD.MM.YYYY'),
            deadlineText: ''
        },
        {
            category: 'Zahlungen',
            subcategory: 'von Paketleistungen:',
            days: 7,
            conditionText: 'Zahlung des Gesamtpreises',
            type: 'days',
            key: `${+new Date()}-payment-2`,
            deadlineDate: startAt.clone().subtract(7, 'day').format('DD.MM.YYYY'),
            deadlineText: ''
        },
        {
            category: 'Stornokosten',
            subcategory: 'bei Stornierung von Paketleistungen:',
            days: 60,
            conditionText: 'kostenfrei',
            type: 'days',
            key: `${+new Date()}-cancelation-1`,
            deadlineDate: startAt.clone().subtract(60, 'day').format('DD.MM.YYYY'),
            deadlineText: ''
        },
        {
            category: 'Stornokosten',
            subcategory: 'bei Stornierung von Paketleistungen:',
            days: 28,
            conditionText: '30% des Paketpreises',
            type: 'days',
            key: `${+new Date()}-cancelation-2`,
            deadlineDate: startAt.clone().subtract(28, 'day').format('DD.MM.YYYY'),
            deadlineText: ''
        },
        {
            category: 'Stornokosten',
            subcategory: 'bei Stornierung von Paketleistungen:',
            days: 14,
            conditionText: '50% des Paketpreises',
            type: 'days',
            key: `${+new Date()}-cancelation-3`,
            deadlineDate: startAt.clone().subtract(14, 'day').format('DD.MM.YYYY'),
            deadlineText: ''
        },
        {
            category: 'Stornokosten',
            subcategory: 'bei Stornierung von Paketleistungen:',
            days: 7,
            conditionText: '75% des Paketpreises',
            type: 'days',
            key: `${+new Date()}-cancelation-4`,
            deadlineDate: startAt.clone().subtract(7, 'day').format('DD.MM.YYYY'),
            deadlineText: ''
        },
        {
            category: 'Stornokosten',
            subcategory: 'bei Stornierung von Paketleistungen:',
            days: 6,
            conditionText: '95% des Paketpreises',
            type: 'days',
            key: `${+new Date()}-cancelation-5`,
            deadlineDate: startAt.clone().subtract(6, 'day').format('DD.MM.YYYY'),
            deadlineText: ''
        },
    ];

    conditions.en = [
        {
            category: 'Angebotsoption',
            subcategory: 'zum Paketpreis:',
            days: null,
            conditionText: '',
            type: 'date',
            key: `${+new Date()}-offer-1`,
            deadlineDate: offerdate.toLocaleDateString('de-DE'),
            deadlineText: ''
        },
        {
            category: 'Zahlungen',
            subcategory: 'von Paketleistungen:',
            days: 60,
            conditionText: '20% Anzahlung vom Paketpreis',
            type: 'days',
            key: `${+new Date()}-payment-1`,
            deadlineDate: startAt.clone().subtract(60, 'day').format('DD.MM.YYYY'),
            deadlineText: ''
        },
        {
            category: 'Zahlungen',
            subcategory: 'von Paketleistungen:',
            days: 7,
            conditionText: 'Zahlung des Gesamtpreises',
            type: 'days',
            key: `${+new Date()}-payment-2`,
            deadlineDate: startAt.clone().subtract(7, 'day').format('DD.MM.YYYY'),
            deadlineText: ''
        },
        {
            category: 'Stornokosten',
            subcategory: 'bei Stornierung von Paketleistungen:',
            days: 60,
            conditionText: 'kostenfrei',
            type: 'days',
            key: `${+new Date()}-cancelation-1`,
            deadlineDate: startAt.clone().subtract(60, 'day').format('DD.MM.YYYY'),
            deadlineText: ''
        },
        {
            category: 'Stornokosten',
            subcategory: 'bei Stornierung von Paketleistungen:',
            days: 28,
            conditionText: '30% des Paketpreises',
            type: 'days',
            key: `${+new Date()}-cancelation-2`,
            deadlineDate: startAt.clone().subtract(28, 'day').format('DD.MM.YYYY'),
            deadlineText: ''
        },
        {
            category: 'Stornokosten',
            subcategory: 'bei Stornierung von Paketleistungen:',
            days: 14,
            conditionText: '50% des Paketpreises',
            type: 'days',
            key: `${+new Date()}-cancelation-3`,
            deadlineDate: startAt.clone().subtract(14, 'day').format('DD.MM.YYYY'),
            deadlineText: ''
        },
        {
            category: 'Stornokosten',
            subcategory: 'bei Stornierung von Paketleistungen:',
            days: 7,
            conditionText: '75% des Paketpreises',
            type: 'days',
            key: `${+new Date()}-cancelation-4`,
            deadlineDate: startAt.clone().subtract(7, 'day').format('DD.MM.YYYY'),
            deadlineText: ''
        },
        {
            category: 'Stornokosten',
            subcategory: 'bei Stornierung von Paketleistungen:',
            days: 6,
            conditionText: '95% des Paketpreises',
            type: 'days',
            key: `${+new Date()}-cancelation-5`,
            deadlineDate: startAt.clone().subtract(6, 'day').format('DD.MM.YYYY'),
            deadlineText: ''
        },
    ];

    if (!state.order.orderLocale || !conditions[state.order.orderLocale]) {
        state.order.orderLocale = 'de_DE';
    }

    return conditions[state.order.orderLocale];
};

export const defaultFreeplaces = function () {
    return [
        {
            freePlaces: 1,
            numberOfPersons: 21,
            type: 'double',
            key: 1
        },
        {
            freePlaces: 1,
            numberOfPersons: 42,
            type: 'double',
            key: 2
        }
    ];
};

export const defaultOrderContingent = function () {
    return {
        hotelContingent: {
            single: '5',
            double: '20'
        },
        ferryContingent: {
            singleCabins: '0',
            doubleCabins: '0'
        },
    };
};

export const defaultHotelPlaceholderValues = {
    hotelType: { category: '', stars: '3' },
    board:     'half_extra_breakfast',
    defaultHotelTimes: [
        { type: 'dinner', time: '20:00:00', firstNightOnly: false},
        { type: 'checkIn', time: '18:00:00', firstNightOnly: true },
        { type: 'checkIn', time: '00:00:00' , firstNightOnly: false },
        { type: 'breakfast', time: '07:30:00', firstNightOnly: false}
    ],
};

export const defaultOtherPlaceholderValues = {
    otherServiceType: '/api/other_service_types/676',
};

export const defaultDayValues = {
    isAutomaticName:     false,
    //addDayWithoutForm: true,
};

export const defaultClientInvoiceValues= function (locale) {
    let introText = {
        'de_DE':    '<p>nachfolgend übersende ich die Rechnung für folgende Fahrt:</p>',
        'fr':       '<p>Je vous envoie ci-dessous la facture du voyage suivant</p>',
        'en':       '<p>I am sending you the invoice for the following journey</p>'
    };

    return {
        type: 'normal',
        percent: '',
        invoiceDate: null,
        dueDate: null,
        addressing: 'formal',
        introText: introText[locale],
        calculationBasis: '',
        introEndText: '',
        amountType: 'amount',
        taxPercentage: 0.0,
        showTax: true,
    }
}

export const defaultEmailTags = [
    { id: 1, name: 'Kunde Anfrage', class: '', icon: 'person_outline' },
    { id: 2, name: 'Kunde Angebot', class: '', icon: 'person_outline' },
    { id: 3, name: 'Kunde Optionserinnerung', class: '', icon: 'person_outline' },
    { id: 4, name: 'Kunde Absage', class: '', icon: 'person_outline' },
    { id: 5, name: 'Kunde Reservierung', class: '', icon: 'person_outline' },
    { id: 6, name: 'Kunde Auftragsbestätigung', class: '', icon: 'person_outline' },
    { id: 7, name: 'Kunde Buchungsstand', class: '', icon: 'person_outline' },
    { id: 8, name: 'Kunde Zimmerliste', class: '', icon: 'person_outline' },
    { id: 9, name: 'Kunde Rechnung', class: '', icon: 'person_outline' },
    { id: 10, name: 'Kunde Stornierung', class: '', icon: 'person_outline' },
    { id: 11, name: 'Hotel Anfrage', class: 'is-blue-dark', icon: 'local_hotel' },
    { id: 12, name: 'Hotel Angebot', class: 'is-blue-dark', icon: 'local_hotel' },
    { id: 13, name: 'Hotel refus', class: 'is-blue-dark', icon: 'local_hotel' },
    { id: 14, name: 'Hotel Option', class: 'is-blue-dark', icon: 'local_hotel' },
    { id: 15, name: 'Hotel Absage', class: 'is-blue-dark', icon: 'local_hotel' },
    { id: 16, name: 'Hotel Reservierung', class: 'is-blue-dark', icon: 'local_hotel' },
    { id: 17, name: 'Hotel Rückbestätigung', class: 'is-blue-dark', icon: 'local_hotel' },
    { id: 18, name: 'Hotel Buchungsstand', class: 'is-blue-dark', icon: 'local_hotel' },
    { id: 19, name: 'Hotel Resa unsicher', class: 'is-blue-dark', icon: 'local_hotel' },
    { id: 20, name: 'Hotel Zimmerliste', class: 'is-blue-dark', icon: 'local_hotel' },
    { id: 21, name: 'Hotel Menü', class: 'is-blue-dark', icon: 'local_hotel' },
    { id: 22, name: 'Hotel Menüauswahl gesendet', class: 'is-blue-dark', icon: 'local_hotel' },
    { id: 23, name: 'Hotel Rechnung', class: 'is-blue-dark', icon: 'local_hotel' },
    { id: 24, name: 'Hotel Stornierung', class: 'is-blue-dark', icon: 'local_hotel' },
    { id: 19, name: 'Hotel Allgemein', class: 'is-blue-dark', icon: 'local_hotel' },
    { id: 20, name: 'Zusatzleistung Anfrage', class: '', icon: 'more_horiz' },
    { id: 21, name: 'Zusatzleistung Angebot', class: '', icon: 'more_horiz' },
    { id: 22, name: 'Zusatzleistung refus', class: '', icon: 'more_horiz' },
    { id: 23, name: 'Zusatzleistung Option', class: '', icon: 'more_horiz' },
    { id: 24, name: 'Zusatzleistung Absage', class: '', icon: 'more_horiz' },
    { id: 25, name: 'Zusatzleistung Reservierung', class: '', icon: 'more_horiz' },
    { id: 26, name: 'Zusatzleistung Rückbestätigung', class: '', icon: 'more_horiz' },
    { id: 27, name: 'Zusatzleistung Buchungsstand', class: '', icon: 'more_horiz' },
    { id: 28, name: 'Zusatzleistung Rechnung', class: '', icon: 'more_horiz' },
    { id: 29, name: 'Zusatzleistung Stornierung', class: '', icon: 'more_horiz' },
];

export const defaultRoomListTypes = [
    {
        value: 'hotel',
        name: 'Hotels (Excel mit Passdaten)'
    },
    {
        value: 'hotel_short_excel',
        name: 'Hotels (Excel kurz ohne Passdaten)'
    },
    {
        value: 'hotel_short',
        name: 'Hotels (Word)'
    },
    {
        value: 'hotel_pdf',
        name: 'Hotels (PDF)'
    },
    {
        value: 'moby',
        name: 'Moby Lines'
    },
    {
        value: 'corsica',
        name: 'Corsica Ferries'
    },
    {
        value: 'corsica_motorbike',
        name: 'Corsica Ferries mit Motorrad'
    },
    {
        value: 'gnv',
        name: 'Grandi Navi Veloci'
    },
    {
        value: 'gmd',
        name: 'Grimaldi'
    },
    {
        value: 'meridionale',
        name: 'La Méridionale'
    }
];

export const defaultRoomListPage = {
    type: 'hotel_pdf'
};

export const clientInvoiceIntroEndText = function (form, oldInvoiceId, currency, organisation, locale) {
    const { amount, type } = form;
    const dueDate = fullYear(form.dueDate);
    // round to cents: float residues like -0.0000001 would otherwise count as a refund
    const cents = Math.round((parseFloat(amount) || 0) * 100);
    // Welcome Tours is a Swiss company: the German VAT (§ 25 UStG) notice does not apply
    const isWelcome = !!organisation && (organisation.id === 3 || organisation.name === 'Welcome Tours');
    const showVatNotice = type !== 'cancelation' && !isWelcome;

    if(locale === 'de_DE') {

        return `
                <p>
                    ${ showVatNotice ? `<span>Es handelt sich um Reiseleistungen gemäß § 25 UStG oder mit Leistungsort im Drittlandsgebiet gemäß § 3a UStG; ein Vorsteuerabzug ist ausgeschlossen.</span>` : ''}
                    ${ showVatNotice ? '<br /><br />' : '' }
                        ${(cents > 0 && type === 'prepayment') ? `<span>Wir bitten um Überweisung des Anzahlungsbetrags auf unser unten genanntes Konto bis zum ${dueDate} und danken für den erteilten Auftrag.</span>` : ''}
                        ${(cents > 0 && (type === 'normal' || type === 'final')) ? `<span>Wir bitten um Überweisung des Rechnungsbetrags auf unser unten genanntes Konto bis zum ${dueDate} und danken für den erteilten Auftrag.</span>`: ''}
                        ${(cents > 0 && type === 'cancelation') ? `<span>Wir bedauern, dass Sie ihre Reise stornieren und wir Ihnen Stornokosten weiterberechnen mussten. Bitte überweisen Sie die Stornokosten auf unser unten genanntes Konto bis zum ${dueDate}.</span>`: ''}
                        ${cents === 0 ? '<span>Die Rechnungssumme wurde bereits beglichen, sodass keine weitere Überweisung nötig ist.</span>' : ''}
                        ${cents < 0 ? `<span>Wir werden Ihnen den zu viel bezahlten Betrag in den nächsten Tagen zurückerstatten.</span>` : ''}
                </p>
            `;
    }
    if(locale === 'fr') {

        return `
                <p>
                    ${ showVatNotice ? `<span>Il s'agit de prestations de voyage conformément au § 25 de la loi allemande sur la TVA ou avec lieu de prestation dans un pays tiers conformément au § 3a de la loi allemande sur la TVA ; la déduction de la taxe en amont est exclue.</span>` : ''}
                    ${ showVatNotice ? '<br /><br />' : '' }
                        ${(cents > 0 && type === 'prepayment') ? `<span>Nous vous prions de bien vouloir virer le montant de l'acompte sur notre compte mentionné ci-dessous avant le ${dueDate} et vous remercions de la commande passée.</span>` : ''}
                        ${(cents > 0 && (type === 'normal' || type === 'final')) ? `<span>Nous vous prions de bien vouloir virer le montant de la facture sur notre compte mentionné ci-dessous avant le ${dueDate} et vous remercions de la commande passée.</span>`: ''}
                        ${(cents > 0 && type === 'cancelation') ? `<span>Nous regrettons que vous ayez annulé votre voyage et que nous ayons dû vous facturer des frais d'annulation. Veuillez virer les frais d'annulation sur notre compte mentionné ci-dessous avant le ${dueDate}.</span>`: ''}
                        ${cents === 0 ? '<span>Le montant de la facture a déjà été réglé, il n\'est donc pas nécessaire d\'effectuer un autre virement.</span>' : ''}
                        ${cents < 0 ? `<span>Nous vous rembourserons le montant payé en trop dans les prochains jours.</span>` : ''}
                </p>
            `;
    }


        return `
                <p>
                    ${ showVatNotice ? `<span>These are travel services in accordance with Section 25 of the German VAT Act or with place of performance in a third country in accordance with Section 3a of the German VAT Act; input tax deduction is excluded.</span>` : ''}
                    ${ showVatNotice ? '<br /><br />' : '' }
                        ${(cents > 0 && type === 'prepayment') ? `<span>We kindly ask you to transfer the deposit amount to our account mentioned below by ${dueDate} and thank you for the order placed.</span>` : ''}
                        ${(cents > 0 && (type === 'normal' || type === 'final')) ? `<span>Please transfer the invoice amount to our account mentioned below by ${dueDate} and thank you for placing the order.</span>`: ''}
                        ${(cents > 0 && type === 'cancelation') ? `<span>We regret that you had to cancel your trip and that we had to charge you cancellation fees. Please transfer the cancellation costs to our account mentioned below by ${dueDate}.</span>`: ''}
                        ${cents === 0 ? '<span>The invoice amount has already been paid, so no further transfer is necessary.</span>' : ''}
                        ${cents < 0 ? `<span>We will refund the overpaid amount to you within the next few days.</span>` : ''}
                </p>
            `;



};

export const clientInvoiceIntroText = function (form, oldInvoiceId, currency, locale) {
    const { type } = form;

    return;
};

export const defaultTripDetailGenerateSettings = {
    _route: true,
    _generalInfos: true,
    _questionaire: true,
    print: false,
    coverLetter: null,
    detailed_route: null,
    menu: null,

};

export const defaultItemPrice = {
    name: 'Zuschlag',
    quantityType: 'per_person',
    limitType: 'validIfLimit',
    quantity: null,
    billingType: 'included',
    inCalculation: true,
};

export const defaultConceptClientId = 4715;

export const otherTypesExcluded = [
    'financial',
];
export const defaultTags = {
    hotels: [
        'Hotel im Stadtzentrum',
        'Hotel am Stadtrand',
        'Hotel außerhalb',
        'Hotel im Gewerbegebiet',
        'Strandhotel',
        'Strandnähe',
        'Klimaanlage',
        'Minibar',
        'Safe',
        'Deutsches TV',
        'Schwimmbad (innen)',
        'Schwimmbad (außen)',
        'Spa',
        'Fahrstuhl',
        'Restaurant',
        'Bar'
    ]
};

export const additionalProviderProperties = [
    {
        additionalIdentifier: 'organisation-1',
        name: 'Kundennummer Welcometours',
        value: '',
    },
    {
        additionalIdentifier: 'organisation-2',
        name: 'Kundennummer Eurobintrading',
        value: '',
    },
    {
        additionalIdentifier: 'organisation-3',
        name: 'Kundennummer Buspaket',
        value: '',
    },
    {
        additionalIdentifier: 'organisation-4',
        name: 'Kundennummer we tours',
        value: '',
    },

];

export const driverRoomType = null;
export const driverCabinType = null;

export const tagCommissionPresets = [
    {
        tag: 'Eric Trinez',
        commissionSource: 'earnings',
        commission: 50,
        commissionCostDeduction: 4,
    },
    {
        tag: 'Eurobin',
        commissionSource: 'revenue',
        commission: 3,
        commissionCostDeduction: 0,
    },
    {
        tag: 'Buspaket',
        commissionSource: 'revenue',
        commission: 4,
        commissionCostDeduction: 0,
    },
    {
        tag: 'WeTours',
        commissionSource: 'revenue',
        commission: 4,
        commissionCostDeduction: 0,
    },
];

export const defaultUserDashboardFilters = function () {
    return {
        isRequests: true,
        type: 'orders',

        // Filters
        _search: '',
        tripName: '',
        users: [],

        hotel: {
            destination: null
        },
        ferry: {
            startPort: null,
            endPort: null,
        },
        train: {
            startTrainStation: null,
            endTrainStation: null,
        },
        airline: {
            startAirport: null,
            endAirport: null
        },
        other: {
            otherServiceTypeCategory: null,
        },

        // Orders
        destinations: [],
        country: null,
        organisation: null,
        mainLanguage: [],
        durationDays: null,

        // Request
        agency: null,
        orderStatus: [],
        requestSource: [],
        startAt: null,
        endAt: null,
        requestStatus: [],
        traitTags: [],

        // Placeholder
        notRequestStatus: null,
        clientOfferStatus: null,
        location: {
            area: null,
            destination: null
        },
    }
}
